// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TheaterRouteImport } from './routes/theater'
import { Route as StatusRouteImport } from './routes/status'
import { Route as SeoCheckRouteImport } from './routes/seo-check'
import { Route as ResourcesRouteImport } from './routes/resources'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as NewsRouteImport } from './routes/news'
import { Route as EmbedRouteImport } from './routes/embed'
import { Route as AboutRouteImport } from './routes/about'
import { Route as SplatRouteImport } from './routes/$'
import { Route as IndexRouteImport } from './routes/index'

const TheaterRoute = TheaterRouteImport.update({
            id: '/theater',path: '/theater',getParentRoute: () => rootRouteImport
          })
const StatusRoute = StatusRouteImport.update({
            id: '/status',path: '/status',getParentRoute: () => rootRouteImport
          })
const SeoCheckRoute = SeoCheckRouteImport.update({
            id: '/seo-check',path: '/seo-check',getParentRoute: () => rootRouteImport
          })
const ResourcesRoute = ResourcesRouteImport.update({
            id: '/resources',path: '/resources',getParentRoute: () => rootRouteImport
          })
const PrivacyRoute = PrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => rootRouteImport
          })
const NewsRoute = NewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => rootRouteImport
          })
const EmbedRoute = EmbedRouteImport.update({
            id: '/embed',path: '/embed',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const SplatRoute = SplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,SplatRoute: SplatRoute,AboutRoute: AboutRoute,EmbedRoute: EmbedRoute,NewsRoute: NewsRoute,PrivacyRoute: PrivacyRoute,ResourcesRoute: ResourcesRoute,SeoCheckRoute: SeoCheckRoute,StatusRoute: StatusRoute,TheaterRoute: TheaterRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)